// rules.jsx
import React, { useEffect } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setBackButtonUrl } from '../uiSlice';

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: themeData } = useSelector((state) => state.theme);
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate('/game');
  };

  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-top">
          <img
            src={process.env.REACT_APP_S3_PATH + themeData?.logo}
            alt="Where's that words?"
            className="user-rules-image"
          />
        </div>
        <div className="user-rules-bottom">
          <div className="user-rules-big-title">{themeData?.main_title}</div>
          <div className="user-rules-heading">Rules</div>
          <ul className="user-rules-list">
            {
              themeData?.rules.map((rules, index) => (
                <li key={index}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button style={{
                ...(themeData?.button_backgroundcolor && { backgroundColor: themeData.button_backgroundcolor }),
                ...(themeData?.button_color && { color: themeData.button_color }),
              }}
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserRules;
